import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import TabNavigation from 'components/TabNavigation';
import LayoutContent from 'components/main-layout/LayoutContent';
import { getUserInfo } from 'utils/auth';
import { getSubdomain } from 'utils/helpers/routing';
import { usePermissionsContext } from 'store/permissions';
import { useActiveClientContext } from 'store/active-client';
import { PermissionKeys } from 'store/types';
import { useTranslation } from 'react-i18next';

interface IProps {
  isLoading?: boolean;
  error?: unknown;
  children: React.ReactNode;
}

const InnerWrapper: FC<IProps> = ({ isLoading, children, error }) => {
  const { t } = useTranslation();
  const { checkPermission } = usePermissionsContext();
  const { client } = useActiveClientContext();

  const userInfo = getUserInfo();
  const isOperatorMode = getSubdomain() === 'operators';

  let tabItems = [
    {
      to: '/structure/groups',
      label: t('structure.groups.title'),
    },
    {
      to: '/structure/roles',
      label: t('structure.roles.title'),
    },
    {
      to: '/structure/employees',
      label: t('structure.employees.title'),
    },
    {
      to: '/structure/scenarios',
      label: t('structure.scenarios.title'),
    },
    {
      to: '/structure/multi-actions',
      label: t('structure.multiActions.title'),
    },
  ];

  if (
    (userInfo.featureForm76 && checkPermission(PermissionKeys.CAN_MANAGE_LEAVES)) ||
    (isOperatorMode && client?.is_form_76)
  ) {
    tabItems = [
      ...tabItems,
      {
        to: '/structure/overtimes',
        label: t('structure.overtime.overtimeView'),
      },
    ];
  }

  return (
    <MainLayout title={t('structure.title')}>
      <TabNavigation tabs={tabItems} />
      <LayoutContent
        isLoading={isLoading}
        error={error}
      >
        {children}
      </LayoutContent>
    </MainLayout>
  );
};

export default InnerWrapper;
